export const getOffers = ({ serviceOfferReducer: { offers = [] } = {} }) =>
  offers;
export const getOffersFilter = ({
  serviceOfferReducer: { filter = {} } = {},
}) => filter;
export const getOffersCount = ({ serviceOfferReducer: { count = 0 } = {} }) =>
  count;
